<ng-container *ngIf="value">
    <b>{{symbol}} </b> <code>{{amount | number: decimalPipeOptions}}</code>
</ng-container>